module.exports = __webpack_public_path__ + "static/img/circle4.17d3226.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/circle4.gif
// module id = p8Jm
// module chunks = 0